import * as React from "react";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { IFilterData } from "./FilterData";
import { CircularProgress, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		changing: {
			"& input": {
				color: 'red',
				fontStyle: 'italic',
			}
		}
	}),
);

interface IProps {
	value: IFilterData,
	onChange: (value: IFilterData) => void,
	options: IFilterData[],
	isLoading: boolean,

	onFocus: () => void,
	
	placeholder: string,
	noOptionsMessage: string,
	className: string,
	changing: boolean,
}

export default function Autoselect(props: IProps)
{
	const classes = useStyles();
	const { t } = useTranslation();

	return <Autocomplete
		freeSolo
		value={props.value}
		loading={props.isLoading}
		className={props.className}
		options={props.options}
		
		onChange={(event, newResult) => {
			props.onChange(newResult as IFilterData);
		}}

		onFocus={props.onFocus}

		clearText={t("common.action.clear")}
		noOptionsText={props.noOptionsMessage}
		getOptionSelected={(option, value) => option.value === value.value}
		getOptionLabel={(option) => option.label}
		openText={t("common.action.open")}
		closeText={t("common.action.close")}
		loadingText={t("common.loading") + "..."}
		renderInput={params => (
			<TextField
				{...params}
				className={clsx({
					[classes.changing]: props.changing
				})}
				placeholder={props.placeholder}
				variant="standard"
				fullWidth
				error={props.changing}
				InputProps={{
					...params.InputProps,
					autoComplete: 'disabled',
					endAdornment: (
						<React.Fragment>
							{props.isLoading ? <CircularProgress color="inherit" size={20} /> : null}
							{params.InputProps.endAdornment}
						</React.Fragment>
					),
				}}
			/>
		)}

	/>;
}
